//Redux Toolkit
import { configureStore } from "@reduxjs/toolkit";

//Middleware
//import loggerMiddleware from "../middleware/redux-middleware-logger";

//Slices
import { appStatusSlice } from "../slices/app-status-slice";
import { areaInfoSlice } from "../../../area-info/redux/slices/area-info-slice";
import { mapSettingsSlice } from "../../../map/redux/slices/map-settings-slice";
import { resultListSlice } from "../../../results/redux/slices/result-list-slice";
import { facetSlice } from "../../../facets/redux/slices/facet-slice";

//API
import { searchApi } from "../api/search-api";
import { searchQmiApi } from "../api/search-qmi-api";

const communityFinderStore = configureStore({
	reducer: {
		[appStatusSlice.reducerPath]: appStatusSlice.reducer,

		//RTK Query API
		//Community Finder API
		[searchApi.reducerPath]: searchApi.reducer,

		//QMI API
		[searchQmiApi.reducerPath]: searchQmiApi.reducer,

		//Slices
		[areaInfoSlice.reducerPath]: areaInfoSlice.reducer,

		[mapSettingsSlice.reducerPath]: mapSettingsSlice.reducer,

		[resultListSlice.reducerPath]: resultListSlice.reducer,

		[facetSlice.reducerPath]: facetSlice.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
			//NOTE: Uncomment this if you want more Redux logging in the console.
			//.concat(loggerMiddleware)

			//RTK Query API
			.concat(searchApi.middleware, searchQmiApi.middleware),
});

// Get the type of our store variable
export type AppStore = typeof communityFinderStore;

export type RootState = ReturnType<AppStore["getState"]>;

export type AppDispatch = AppStore["dispatch"];

export default communityFinderStore;
